import { FeatureAppConfig } from '@ngw6fa/feature-app';
import { ModelOverviewIntegratorOptions } from '../create-options-from-query-params';
const API_KEY_CONTENT: string = 'GLS.O6Svm5JjmczW2hulUlZGeZI8kY14zI90YKsraHYZrdRXGMvuHOu1KjzyS9yfK80R';

export function createFiveStarsAppConfig({
  faServicesUrl,
}: ModelOverviewIntegratorOptions): FeatureAppConfig {
  return {
    apiKeyContent: API_KEY_CONTENT,
    faServicesUrl,
    hasContentConfig: true,
    mode: "standalone",
    // For standalone // dealer-reviews // model-reviews modes
    carImage: "https://media.volkswagen.com/Vilma/V/E81/2026/Side_Left/cd38e0aaef218d1031d5d762d2e3b4640f48a4d79c099fc4bbc18bb85b0753b1.png?width=480",
    salesModelCode: "E813MN",
    sectionLabel: "Model Reviews",
    // For dealer-reviews-name // dealer-reviews modes
    dealerConfiguration: {
      "address1": "601 Airport Rd S",
      "city": "Naples",
      "dealerid": "405024",
      "distance": 109.43709720877395,
      "name": "Volkswagen of Naples",
      "phone": "2394654669",
      "postalcode": "34104",
      "state": "FL",
      "staticMapsUrl": "https://maps.googleapis.com/maps/api/staticmap?markers=icon:https://vw.com/content/dam/onehub_pkw/importers/us/vwcom/tier2/google-maps/pin_icon.png|shadow:false|33.8971,-118.3710&size=421x208&zoom=12&client=gme-volkswagenag3&signature=3IJ1ILlbyYI2di8Ze9HMoA4-vsA=",
      "url": "https://www.vwofnaples.com",
    }
  };
}